export default __webpack_public_path__ + "static/media/37.949e5e4e.png";